export const ModalActionTypes = {
  HANDLE_MODAL: 'HANDLE_MODAL',
  HANDLE_MODAL_TRANSFER: 'HANDLE_MODAL_TRANSFER',
  HANDLE_MODAL_WALLET: 'HANDLE_MODAL_WALLET'
};
